import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { EMPTY_CELL_VALUE } from '../../../../NRReactGridCustomComponents/CellComponent/CellComponent';

function NRJiraTicketIssueTypeFormatter({ value, row }) {
  const theme = useTheme();

  if (value == null || value === '') {
    return EMPTY_CELL_VALUE;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1), minWidth: 0 }}>
      {row?.issueTypeIconUrl && (
        <Box
          component="img"
          src={row.issueTypeIconUrl}
          alt=""
          aria-hidden
          sx={{ width: theme.spacing(2), height: theme.spacing(2), flexShrink: 0 }}
        />
      )}
      <Typography variant="body2" color="text.primary" noWrap>
        {value}
      </Typography>
    </Box>
  );
}

export function NRJiraTicketIssueTypeProvider(props) {
  return <DataTypeProvider formatterComponent={NRJiraTicketIssueTypeFormatter} {...props} />;
}
